module.exports = __webpack_public_path__ + "img/lock-open--white.5ee0f10a.svg";